import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../context/TokenContext";
import { useFal } from "../context/FalContext";

// 78 Rider-Waite kartı — yerel görseller
const TAROT_KARTLARI = [
  // Major Arcana (0-21)
  { id: "major-0",  isim: "The Fool",           tr: "Deli",              url: "/tarot/The Fool.jpg",              anlam: "Yeni başlangıçlar, özgürlük, macera" },
  { id: "major-1",  isim: "The Magician",        tr: "Büyücü",            url: "/tarot/The Magician.jpg",          anlam: "Güç, irade, beceri, yaratıcılık" },
  { id: "major-2",  isim: "High Priestess",      tr: "Yüksek Rahibe",     url: "/tarot/The High Priestess.jpg",    anlam: "Sezgi, gizem, iç ses, bilinçaltı" },
  { id: "major-3",  isim: "The Empress",         tr: "İmparatoriçe",      url: "/tarot/The Empress.jpg",           anlam: "Bolluk, doğurganlık, güzellik, doğa" },
  { id: "major-4",  isim: "The Emperor",         tr: "İmparator",         url: "/tarot/The Emperor.jpg",           anlam: "Otorite, yapı, düzen, liderlik" },
  { id: "major-5",  isim: "The Hierophant",      tr: "Aziz",              url: "/tarot/The Hierophant.jpg",        anlam: "Gelenek, inanç, rehberlik, kurumlar" },
  { id: "major-6",  isim: "The Lovers",          tr: "Aşıklar",           url: "/tarot/The Lovers.jpg",            anlam: "Aşk, uyum, değerler, seçimler" },
  { id: "major-7",  isim: "The Chariot",         tr: "Savaş Arabası",     url: "/tarot/The Chariot.jpg",           anlam: "Zafer, kontrol, kararlılık, güç" },
  { id: "major-8",  isim: "Strength",            tr: "Güç",               url: "/tarot/Strength.jpg",              anlam: "Cesaret, sabır, iç güç, şefkat" },
  { id: "major-9",  isim: "The Hermit",          tr: "Münzevi",           url: "/tarot/The Hermit.jpg",            anlam: "İçe dönüş, yalnızlık, bilgelik, rehberlik" },
  { id: "major-10", isim: "Wheel of Fortune",    tr: "Kader Çarkı",       url: "/tarot/The Wheel of Fortune.jpg",  anlam: "Dönüşüm, şans, kader, döngüler" },
  { id: "major-11", isim: "Justice",             tr: "Adalet",            url: "/tarot/Justice.jpg",               anlam: "Denge, hakikat, adalet, sebep-sonuç" },
  { id: "major-12", isim: "The Hanged Man",      tr: "Asılan Adam",       url: "/tarot/The Hanged Man.jpg",        anlam: "Bekleme, teslim olma, farklı bakış açısı" },
  { id: "major-13", isim: "Death",               tr: "Ölüm",              url: "/tarot/Death.jpg",                 anlam: "Dönüşüm, bitiş, yenilenme, geçiş" },
  { id: "major-14", isim: "Temperance",          tr: "Denge",             url: "/tarot/Temperance.jpg",            anlam: "Uyum, sabır, denge, ölçülülük" },
  { id: "major-15", isim: "The Devil",           tr: "Şeytan",            url: "/tarot/The Devil.jpg",             anlam: "Bağlar, korkular, kısıtlamalar, madde" },
  { id: "major-16", isim: "The Tower",           tr: "Kule",              url: "/tarot/The Tower.jpg",             anlam: "Ani değişim, yıkım, uyanış, özgürleşme" },
  { id: "major-17", isim: "The Star",            tr: "Yıldız",            url: "/tarot/The Star.jpg",              anlam: "Umut, ilham, yenilenme, rehberlik" },
  { id: "major-18", isim: "The Moon",            tr: "Ay",                url: "/tarot/The Moon.jpg",              anlam: "Yanılsamalar, korku, bilinçaltı, sezgi" },
  { id: "major-19", isim: "The Sun",             tr: "Güneş",             url: "/tarot/The Sun.jpg",               anlam: "Neşe, başarı, canlılık, aydınlık" },
  { id: "major-20", isim: "Judgement",           tr: "Yargı",             url: "/tarot/Judgement.jpg",             anlam: "Yenilenme, içsel çağrı, af, uyanış" },
  { id: "major-21", isim: "The World",           tr: "Dünya",             url: "/tarot/The World.jpg",             anlam: "Tamamlanma, bütünlük, başarı, yolculuk" },
  // Minor Arcana — Cups
  { id: "cups-1",   isim: "Ace of Cups",         tr: "Kupalar Ası",       url: "/tarot/Ace of Cups.jpg",           anlam: "Yeni aşk, duygusal başlangıç, sezgi" },
  { id: "cups-2",   isim: "Two of Cups",         tr: "Kupalar İkisi",     url: "/tarot/Two of Cups.jpg",           anlam: "Birlik, ortaklık, karşılıklı çekim" },
  { id: "cups-3",   isim: "Three of Cups",       tr: "Kupalar Üçü",       url: "/tarot/Three of Cups.jpg",         anlam: "Kutlama, dostluk, topluluk, neşe" },
  { id: "cups-4",   isim: "Four of Cups",        tr: "Kupalar Dördü",     url: "/tarot/Four of Cups.jpg",          anlam: "Hayal kırıklığı, içe kapanma, yeniden değerlendirme" },
  { id: "cups-5",   isim: "Five of Cups",        tr: "Kupalar Beşi",      url: "/tarot/Five of Cups.jpg",          anlam: "Kayıp, pişmanlık, yas, hayal kırıklığı" },
  { id: "cups-6",   isim: "Six of Cups",         tr: "Kupalar Altısı",    url: "/tarot/Six of Cups.jpg",           anlam: "Nostalji, geçmiş, masumiyet, anılar" },
  { id: "cups-7",   isim: "Seven of Cups",       tr: "Kupalar Yedisi",    url: "/tarot/Seven of Cups.jpg",         anlam: "Hayal gücü, illüzyon, seçenekler, fantezi" },
  { id: "cups-8",   isim: "Eight of Cups",       tr: "Kupalar Sekizi",    url: "/tarot/Eight of Cups.jpg",         anlam: "Terk etme, arayış, yolculuk, hayal kırıklığı" },
  { id: "cups-9",   isim: "Nine of Cups",        tr: "Kupalar Dokuzu",    url: "/tarot/Nine of Cups.jpg",          anlam: "Dilek, memnuniyet, mutluluk, tatmin" },
  { id: "cups-10",  isim: "Ten of Cups",         tr: "Kupalar Onu",       url: "/tarot/Ten of Cups.jpg",           anlam: "Aile mutluluğu, uyum, sevgi, huzur" },
  { id: "cups-11",  isim: "Page of Cups",        tr: "Kupalar Paj",       url: "/tarot/Page of Cups.jpg",          anlam: "Yaratıcılık, sezgi, merak, haberci" },
  { id: "cups-12",  isim: "Knight of Cups",      tr: "Kupalar Şövalyesi", url: "/tarot/Knight of Cups.jpg",        anlam: "Romantizm, cazibe, hayal gücü, teklif" },
  { id: "cups-13",  isim: "Queen of Cups",       tr: "Kupalar Kraliçesi", url: "/tarot/Queen of Cups.jpg",         anlam: "Şefkat, sezgi, duygusal güvenlik, empati" },
  { id: "cups-14",  isim: "King of Cups",        tr: "Kupalar Kralı",     url: "/tarot/King of Cups.jpg",          anlam: "Duygusal denge, bilgelik, diplomatik, şefkatli" },
  // Wands
  { id: "wands-1",  isim: "Ace of Wands",        tr: "Asalar Ası",        url: "/tarot/Ace of Wands.jpg",          anlam: "İlham, yeni enerji, potansiyel, yaratıcılık" },
  { id: "wands-2",  isim: "Two of Wands",        tr: "Asalar İkisi",      url: "/tarot/Two of Wands.jpg",          anlam: "Planlama, gelecek, özgürlük, keşif" },
  { id: "wands-3",  isim: "Three of Wands",      tr: "Asalar Üçü",        url: "/tarot/Three of Wands.jpg",        anlam: "İlerleme, genişleme, uzak görüş, liderlik" },
  { id: "wands-4",  isim: "Four of Wands",       tr: "Asalar Dördü",      url: "/tarot/Four of Wands.jpg",         anlam: "Kutlama, ev, topluluk, harmoni" },
  { id: "wands-5",  isim: "Five of Wands",       tr: "Asalar Beşi",       url: "/tarot/Five of Wands.jpg",         anlam: "Çatışma, rekabet, gerilim, mücadele" },
  { id: "wands-6",  isim: "Six of Wands",        tr: "Asalar Altısı",     url: "/tarot/Six of Wands.jpg",          anlam: "Zafer, başarı, tanınma, güven" },
  { id: "wands-7",  isim: "Seven of Wands",      tr: "Asalar Yedisi",     url: "/tarot/Seven of Wands.jpg",        anlam: "Savunma, kararlılık, meydan okuma, ısrar" },
  { id: "wands-8",  isim: "Eight of Wands",      tr: "Asalar Sekizi",     url: "/tarot/Eight of Wands.jpg",        anlam: "Hız, hareket, haberler, ilerleme" },
  { id: "wands-9",  isim: "Nine of Wands",       tr: "Asalar Dokuzu",     url: "/tarot/Nine of Wands.jpg",         anlam: "Dayanıklılık, koruma, yorgunluk, son adım" },
  { id: "wands-10", isim: "Ten of Wands",        tr: "Asalar Onu",        url: "/tarot/Ten of Wands.jpg",          anlam: "Yük, sorumluluk, baskı, tükenmişlik" },
  { id: "wands-11", isim: "Page of Wands",       tr: "Asalar Paj",        url: "/tarot/Page of Wands.jpg",         anlam: "Keşif, heves, enerji, merak" },
  { id: "wands-12", isim: "Knight of Wands",     tr: "Asalar Şövalyesi",  url: "/tarot/Knight of Wands.jpg",       anlam: "Macera, cesaret, enerji, dürtüsellik" },
  { id: "wands-13", isim: "Queen of Wands",      tr: "Asalar Kraliçesi",  url: "/tarot/Queen of Wands.jpg",        anlam: "Özgüven, karizma, bağımsızlık, tutku" },
  { id: "wands-14", isim: "King of Wands",       tr: "Asalar Kralı",      url: "/tarot/King of Wands.jpg",         anlam: "Liderlik, vizyon, girişimcilik, özgüven" },
  // Swords
  { id: "swords-1",  isim: "Ace of Swords",      tr: "Kılıçlar Ası",      url: "/tarot/Ace of Swords.jpg",         anlam: "Netlik, gerçek, keskin zeka, zafer" },
  { id: "swords-2",  isim: "Two of Swords",      tr: "Kılıçlar İkisi",    url: "/tarot/Two of Swords.jpg",         anlam: "Karar verme, denge, kör nokta, çatışma" },
  { id: "swords-3",  isim: "Three of Swords",    tr: "Kılıçlar Üçü",      url: "/tarot/Three of Swords.jpg",       anlam: "Kalp kırıklığı, acı, yas, ihanet" },
  { id: "swords-4",  isim: "Four of Swords",     tr: "Kılıçlar Dördü",    url: "/tarot/Four of Swords.jpg",        anlam: "Dinlenme, iyileşme, sessizlik, meditasyon" },
  { id: "swords-5",  isim: "Five of Swords",     tr: "Kılıçlar Beşi",     url: "/tarot/Five of Swords.jpg",        anlam: "Çatışma, yenilgi, ihanet, çıkarcılık" },
  { id: "swords-6",  isim: "Six of Swords",      tr: "Kılıçlar Altısı",   url: "/tarot/Six of Swords.jpg",         anlam: "Geçiş, ilerleme, huzur, iyileşme" },
  { id: "swords-7",  isim: "Seven of Swords",    tr: "Kılıçlar Yedisi",   url: "/tarot/Seven of Swords.jpg",       anlam: "Aldatmaca, gizlilik, strateji, kaçış" },
  { id: "swords-8",  isim: "Eight of Swords",    tr: "Kılıçlar Sekizi",   url: "/tarot/Eight of Swords.jpg",       anlam: "Tuzak, kısıtlama, kendi kendini engelleme" },
  { id: "swords-9",  isim: "Nine of Swords",     tr: "Kılıçlar Dokuzu",   url: "/tarot/Nine of Swords.jpg",        anlam: "Kaygı, korku, kâbuslar, umutsuzluk" },
  { id: "swords-10", isim: "Ten of Swords",      tr: "Kılıçlar Onu",      url: "/tarot/Ten of Swords.jpg",         anlam: "Son, acı verici bitiş, ihanet, kurban" },
  { id: "swords-11", isim: "Page of Swords",     tr: "Kılıçlar Paj",      url: "/tarot/Page of Swords.jpg",        anlam: "Merak, zeka, dürüstlük, dikkatli ol" },
  { id: "swords-12", isim: "Knight of Swords",   tr: "Kılıçlar Şövalyesi",url: "/tarot/Knight of Swords.jpg",      anlam: "Hırs, hız, doğrudan, cesaret" },
  { id: "swords-13", isim: "Queen of Swords",    tr: "Kılıçlar Kraliçesi",url: "/tarot/Queen of Swords.jpg",       anlam: "Netlik, bağımsızlık, zeka, dürüstlük" },
  { id: "swords-14", isim: "King of Swords",     tr: "Kılıçlar Kralı",    url: "/tarot/King of Swords.jpg",        anlam: "Otorite, mantık, güç, karar alma" },
  // Pentacles
  { id: "pentacles-1",  isim: "Ace of Pentacles",     tr: "Pentaklar Ası",       url: "/tarot/Ace of Pentacles.jpg",      anlam: "Yeni fırsat, bolluk, maddi başlangıç" },
  { id: "pentacles-2",  isim: "Two of Pentacles",     tr: "Pentaklar İkisi",     url: "/tarot/Two of Pentacles.jpg",      anlam: "Denge, esneklik, uyum, çoklu görev" },
  { id: "pentacles-3",  isim: "Three of Pentacles",   tr: "Pentaklar Üçü",       url: "/tarot/Three of Pentacles.jpg",    anlam: "İşbirliği, ustalık, takım çalışması" },
  { id: "pentacles-4",  isim: "Four of Pentacles",    tr: "Pentaklar Dördü",     url: "/tarot/Four of Pentacles.jpg",     anlam: "Güvenlik, kontrol, tutumluluk, direnç" },
  { id: "pentacles-5",  isim: "Five of Pentacles",    tr: "Pentaklar Beşi",      url: "/tarot/Five of Pentacles.jpg",     anlam: "Maddi sıkıntı, yalnızlık, kayıp, yoksunluk" },
  { id: "pentacles-6",  isim: "Six of Pentacles",     tr: "Pentaklar Altısı",    url: "/tarot/Six of Pentacles.jpg",      anlam: "Cömertlik, paylaşım, denge, bağış" },
  { id: "pentacles-7",  isim: "Seven of Pentacles",   tr: "Pentaklar Yedisi",    url: "/tarot/Seven of Pentacles.jpg",    anlam: "Sabır, uzun vadeli vizyon, değerlendirme" },
  { id: "pentacles-8",  isim: "Eight of Pentacles",   tr: "Pentaklar Sekizi",    url: "/tarot/Eight of Pentacles.jpg",    anlam: "Ustalık, çalışkanlık, odak, öğrenme" },
  { id: "pentacles-9",  isim: "Nine of Pentacles",    tr: "Pentaklar Dokuzu",    url: "/tarot/Nine of Pentacles.jpg",     anlam: "Bağımsızlık, öz yeterlik, lüks, başarı" },
  { id: "pentacles-10", isim: "Ten of Pentacles",     tr: "Pentaklar Onu",       url: "/tarot/Ten of Pentacles.jpg",      anlam: "Miras, aile refahı, kalıcılık, bolluk" },
  { id: "pentacles-11", isim: "Page of Pentacles",    tr: "Pentaklar Paj",       url: "/tarot/Page of Pentacles.jpg",     anlam: "Öğrenme, fırsat, çalışkanlık, pratiklik" },
  { id: "pentacles-12", isim: "Knight of Pentacles",  tr: "Pentaklar Şövalyesi", url: "/tarot/Knight of Pentacles.jpg",   anlam: "Sorumluluk, güvenilirlik, sabır, azim" },
  { id: "pentacles-13", isim: "Queen of Pentacles",   tr: "Pentaklar Kraliçesi", url: "/tarot/Queen of Pentacles.jpg",    anlam: "Pratiklik, güvenlik, şefkat, bolluk" },
  { id: "pentacles-14", isim: "King of Pentacles",    tr: "Pentaklar Kralı",     url: "/tarot/King of Pentacles.jpg",     anlam: "Güvenlik, liderlik, başarı, güvenilirlik" },
];

// 3 rastgele kart çek
const rastgeleKartlar = () => {
  const karistir = [...TAROT_KARTLARI].sort(() => Math.random() - 0.5);
  return karistir.slice(0, 3);
};

// Kart bileşeni — flip animasyonlu
function TarotKart({ kart, pozisyon, acik, onTikla }) {
  const pozisyonlar = {
    gecmis: "Geçmiş",
    simdi: "Şimdi",
    gelecek: "Gelecek",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
      <div style={{ fontSize: 11, color: "rgba(192,132,252,0.7)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600 }}>
        {pozisyonlar[pozisyon]}
      </div>
      <div
        onClick={onTikla}
        style={{
          width: 90, height: 154, borderRadius: 10, cursor: acik ? "default" : "pointer",
          position: "relative", perspective: 1000,
          transition: "transform 0.2s",
          transform: !acik ? "scale(1)" : "scale(1)",
        }}
      >
        {/* Kapalı yüz */}
        {!acik && (
          <div style={{
            width: "100%", height: "100%", borderRadius: 10,
            background: "linear-gradient(135deg, #3B1F6B, #6B2FA0)",
            border: "2px solid rgba(192,132,252,0.5)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
            animation: "kart-nabiz 2s ease-in-out infinite",
          }}>
            <div style={{
              width: "80%", height: "80%", borderRadius: 8,
              border: "1px solid rgba(192,132,252,0.3)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 28,
            }}>✨</div>
          </div>
        )}
        {/* Açık yüz */}
        {acik && kart && (
          <div style={{
            width: "100%", height: "100%", borderRadius: 10,
            overflow: "hidden", border: "2px solid rgba(192,132,252,0.6)",
            boxShadow: "0 8px 32px rgba(192,132,252,0.3)",
            animation: "kart-ac 0.4s ease backwards",
          }}>
            <img
              src={kart.url}
              alt={kart.tr}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.parentElement.style.background = "linear-gradient(135deg, #3B1F6B, #6B2FA0)";
                e.target.parentElement.innerHTML = `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:6px;padding:8px;text-align:center"><span style="font-size:20px">🔮</span><span style="font-size:9px;color:rgba(255,255,255,0.7)">${kart.tr}</span></div>`;
              }}
            />
          </div>
        )}
      </div>
      {acik && kart && (
        <div style={{ textAlign: "center", animation: "fade-yukari 0.4s ease backwards" }}>
          <div style={{ fontSize: 11, color: "#C084FC", fontWeight: 700 }}>{kart.tr}</div>
          <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", marginTop: 2, maxWidth: 90, lineHeight: 1.3 }}>{kart.anlam}</div>
        </div>
      )}
    </div>
  );
}

// Parçacık efekti
function ParticleCanvas() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener("resize", resize);
    const particles = Array.from({ length: 60 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      size: Math.random() * 1.5 + 0.3,
      speedY: -Math.random() * 0.3 - 0.05,
      speedX: (Math.random() - 0.5) * 0.15,
      opacity: Math.random(),
      opSpeed: (Math.random() - 0.5) * 0.006,
    }));
    let id;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.speedX; p.y += p.speedY;
        p.opacity += p.opSpeed;
        if (p.opacity <= 0 || p.opacity >= 1) p.opSpeed *= -1;
        if (p.y < -5) { p.y = canvas.height + 5; p.x = Math.random() * canvas.width; }
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(192,132,252,${p.opacity * 0.6})`;
        ctx.fill();
      });
      id = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(id); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={canvasRef} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 3 }} />;
}

const SS_KEY = "tarot_session";

function ssYukle() {
  try {
    const raw = sessionStorage.getItem(SS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function ssSifirla() {
  sessionStorage.removeItem(SS_KEY);
}

export default function Tarot() {
  const navigate = useNavigate();
  const { tokenBalance } = useToken();
  const { falGonder } = useFal();

  const ss = ssYukle();

  const [ekran, setEkran] = useState(ss?.ekran ?? "giris");
  const [ad, setAd] = useState(ss?.ad ?? "");
  const [niyet, setNiyet] = useState(ss?.niyet ?? "");
  const [kartlar, setKartlar] = useState(ss?.kartlar ?? [null, null, null]);
  const [acikKartlar, setAcikKartlar] = useState(ss?.acikKartlar ?? [false, false, false]);
  const [sonuc, setSonuc] = useState(ss?.sonuc ?? null);
  const [hata, setHata] = useState("");
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => { setTimeout(() => setFadeIn(true), 100); }, []);

  // State değiştiğinde sessionStorage'a kaydet
  useEffect(() => {
    // Yükleniyor ekranını kaydetme (yarım kalmış istek)
    if (ekran === "yukleniyor") return;
    try {
      sessionStorage.setItem(SS_KEY, JSON.stringify({ ekran, ad, niyet, kartlar, acikKartlar, sonuc }));
    } catch { /* quota aşıldıysa sessizce geç */ }
  }, [ekran, ad, niyet, kartlar, acikKartlar, sonuc]);

  const kartCek = () => {
    const yeniKartlar = rastgeleKartlar();
    setKartlar(yeniKartlar);
    setAcikKartlar([false, false, false]);
    setEkran("kart-sec");
  };

  const kartAc = (index) => {
    if (acikKartlar[index]) return;
    const yeni = [...acikKartlar];
    yeni[index] = true;
    setAcikKartlar(yeni);
  };

  const tumKartlarAcikMi = acikKartlar.every(Boolean);

  const tarotBak = async () => {
    if (!tumKartlarAcikMi) return;
    if (tokenBalance < 30) { setHata("Yetersiz token! Tarot için 30 🪙 gerekiyor."); return; }
    setEkran("yukleniyor");
    setHata("");

    try {
      const kartIsimleri = kartlar.map((k, i) => `${["Geçmiş","Şimdi","Gelecek"][i]}: ${k?.tr} (${k?.anlam})`).join(" | ");
      const sonucFal = await falGonder({
        falciId: "lunara", falTuru: "tarot", tokenMiktar: 30,
        fotograflar: [], ekNot: `Ad: ${ad} | Niyet: ${niyet} | Kartlar: ${kartIsimleri}`,
        ad: ad,
        burc: '',
        soru: `Niyet: ${niyet} | Çekilen kartlar: ${kartIsimleri}`,
      });
      if (sonucFal.success) {
        // fallar tablosundan yorumu çekmek yerine, falGonder'in kaydettiği yorumu kullan
        // Sonucu fallardan çekelim
        setSonuc(sonucFal.yorum || "Yorumun hazırlanıyor...");
        setEkran("sonuc");
      }
      else { setHata("Tarot kaydedilemedi."); setEkran("kart-sec"); }
    } catch (err) { setHata("Bağlantı hatası."); setEkran("kart-sec"); }
  };

  const inputStil = {
    width: "100%", background: "rgba(15,8,30,0.7)",
    border: "1px solid rgba(192,132,252,0.3)", borderRadius: 12,
    padding: "14px 16px", color: "#fff", fontSize: 14, fontFamily: "'Trebuchet MS', sans-serif",
  };

  return (
    <div style={{ minHeight: "100vh", maxWidth: 420, margin: "0 auto", position: "relative", overflow: "hidden", fontFamily: "'Trebuchet MS', Tahoma, sans-serif", background: "#0a0314" }}>
      <style>{`
        @keyframes kart-nabiz { 0%,100%{box-shadow:0 8px 24px rgba(0,0,0,0.5)} 50%{box-shadow:0 8px 32px rgba(192,132,252,0.4)} }
        @keyframes kart-ac { from{opacity:0;transform:rotateY(90deg)} to{opacity:1;transform:rotateY(0deg)} }
        @keyframes fade-yukari { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes parlama { 0%,100%{filter:drop-shadow(0 0 8px rgba(192,132,252,0.4))} 50%{filter:drop-shadow(0 0 24px rgba(192,132,252,0.9))} }
        @keyframes donme { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        @keyframes yildiz-titreme { 0%,100%{opacity:0.4;transform:scale(1)} 50%{opacity:1;transform:scale(1.3)} }
        @keyframes sis-kayma { 0%{transform:translateX(-20px);opacity:0.1} 50%{transform:translateX(20px);opacity:0.2} 100%{transform:translateX(-20px);opacity:0.1} }
        * { box-sizing:border-box; margin:0; padding:0; }
        ::-webkit-scrollbar { display:none; }
        input:focus, textarea:focus { outline:none; }
      `}</style>

      {/* Arka plan */}
      <div style={{
        position: "fixed", inset: 0, zIndex: 0,
        backgroundImage: "url('/tarot-bg.png')",
        backgroundSize: "cover", backgroundPosition: "center",
        filter: ekran === "giris" ? "brightness(0.75)" : "brightness(0.2)",
        transition: "filter 1.2s ease",
      }} />

      {/* Koyu overlay */}
      {ekran !== "giris" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1, background: "linear-gradient(180deg,rgba(10,3,20,0.8) 0%,rgba(10,3,20,0.92) 100%)" }} />
      )}

      {/* Sis efekti */}
      <div style={{ position: "fixed", top: "30%", left: "-10%", width: "120%", height: 200, background: "radial-gradient(ellipse,rgba(100,40,160,0.12) 0%,transparent 70%)", animation: "sis-kayma 16s ease-in-out infinite", zIndex: 2, pointerEvents: "none" }} />

      {/* Parçacıklar */}
      <div style={{ position: "fixed", inset: 0, zIndex: 3, pointerEvents: "none" }}>
        <ParticleCanvas />
      </div>

      {/* ===== GİRİŞ ===== */}
      {ekran === "giris" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", padding: "0 24px", opacity: fadeIn ? 1 : 0, transition: "opacity 1.8s ease" }}>
          <div style={{ width: "100%", paddingTop: 52 }}>
            <button onClick={() => navigate(-1)} style={{ background: "rgba(0,0,0,0.5)", border: "1px solid rgba(192,132,252,0.3)", borderRadius: 12, padding: "8px 16px", color: "rgba(192,132,252,0.8)", fontSize: 13, cursor: "pointer" }}>← Geri</button>
          </div>

          <div style={{ textAlign: "center", flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: 90, height: 90, marginBottom: 24, background: "radial-gradient(circle,rgba(192,132,252,0.25) 0%,transparent 70%)", border: "1px solid rgba(192,132,252,0.4)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40, animation: "parlama 3s ease-in-out infinite" }}>
              🔮
            </div>

            <div style={{ fontSize: 11, letterSpacing: 6, color: "rgba(192,132,252,0.7)", textTransform: "uppercase", marginBottom: 14 }}>✦ Lunara ile ✦</div>

            <div style={{ fontSize: 40, fontWeight: 900, color: "#fff", textShadow: "0 0 50px rgba(192,132,252,0.7)", letterSpacing: 3, marginBottom: 10, lineHeight: 1.1 }}>
              Tarot
            </div>

            <div style={{ fontSize: 14, color: "rgba(200,170,255,0.7)", letterSpacing: 1.5, marginBottom: 32, fontStyle: "italic" }}>
              3 Kart · Geçmiş — Şimdi — Gelecek
            </div>

            <div style={{ width: 120, height: 1, background: "linear-gradient(90deg,transparent,rgba(192,132,252,0.6),transparent)", marginBottom: 28 }} />

            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", lineHeight: 1.9, textAlign: "center", maxWidth: 280, marginBottom: 40, fontStyle: "italic" }}>
              "Kartlar sana ne olacağını söylemez. Hangisi olabileceğini gösterir."
            </div>

            <div style={{ display: "flex", gap: 12, marginBottom: 16, justifyContent: "center" }}>
              {["🌙", "⭐", "✨", "🌟", "💫", "🌙"].map((s, i) => (
                <div key={i} style={{ fontSize: 16, animation: `yildiz-titreme ${2 + (i % 3) * 0.6}s ${i * 0.2}s ease-in-out infinite` }}>{s}</div>
              ))}
            </div>
          </div>

          <div style={{ width: "100%", paddingBottom: 60 }}>
            <button onClick={() => setEkran("form")} style={{
              width: "100%", padding: "18px", borderRadius: 16,
              background: "linear-gradient(135deg,rgba(80,30,140,0.95),rgba(140,60,220,0.85),rgba(80,30,140,0.95))",
              border: "1px solid rgba(192,132,252,0.6)", color: "#fff",
              fontSize: 16, fontWeight: 800, cursor: "pointer", letterSpacing: 0.5,
              boxShadow: "0 0 35px rgba(192,132,252,0.35)",
            }}>
              🔮 Kartlarını Çek
            </button>
            <div style={{ textAlign: "center", marginTop: 12, fontSize: 12, color: "rgba(192,132,252,0.5)" }}>30 🪙 token gereklidir</div>
          </div>
        </div>
      )}

      {/* ===== FORM ===== */}
      {ekran === "form" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", paddingBottom: 100, animation: "fade-yukari 0.6s ease backwards" }}>
          <div style={{ padding: "52px 24px 20px", display: "flex", alignItems: "center", gap: 14 }}>
            <button onClick={() => setEkran("giris")} style={{ background: "rgba(0,0,0,0.5)", border: "1px solid rgba(192,132,252,0.3)", borderRadius: 12, padding: "8px 16px", color: "rgba(192,132,252,0.8)", fontSize: 13, cursor: "pointer" }}>← Geri</button>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>Tarot</div>
              <div style={{ fontSize: 11, color: "rgba(192,132,252,0.6)" }}>Lunara seni dinliyor</div>
            </div>
            <div style={{ marginLeft: "auto", fontSize: 12, color: "#C084FC", fontWeight: 700 }}>🪙 {tokenBalance}</div>
          </div>

          <div style={{ margin: "0 24px 24px", height: 1, background: "linear-gradient(90deg,transparent,rgba(192,132,252,0.4),transparent)" }} />

          <div style={{ padding: "0 24px" }}>
            {tokenBalance < 30 && (
              <div onClick={() => navigate("/token-kazan")} style={{ marginBottom: 20, padding: "14px 16px", borderRadius: 14, background: "rgba(239,68,68,0.2)", border: "1px solid rgba(239,68,68,0.4)", color: "#FCA5A5", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span>⚠️ Yetersiz token! {tokenBalance} 🪙 mevcut</span>
                <span style={{ color: "#F472B6", fontWeight: 700 }}>Token Al →</span>
              </div>
            )}

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, color: "rgba(192,132,252,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>✦ Adın</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 10 }}>Lunara sana bu adla hitap edecek</div>
              <input type="text" value={ad} onChange={e => setAd(e.target.value)} placeholder="Adını yaz..." style={inputStil} />
            </div>

            <div style={{ marginBottom: 28 }}>
              <div style={{ fontSize: 11, color: "rgba(192,132,252,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>✦ Niyetin</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginBottom: 10 }}>Kartlara ne sormak istiyorsun?</div>
              <textarea value={niyet} onChange={e => setNiyet(e.target.value)} placeholder="Aklındaki soruyu yaz..." rows={4} style={{ ...inputStil, resize: "none", lineHeight: 1.6 }} />
            </div>

            {hata && (
              <div style={{ marginBottom: 16, padding: "12px 16px", borderRadius: 12, background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#FCA5A5", fontSize: 13 }}>
                ⚠️ {hata}
              </div>
            )}

            <button onClick={kartCek} disabled={!ad.trim() || !niyet.trim() || tokenBalance < 30} style={{
              width: "100%", padding: "18px", borderRadius: 16, fontSize: 16, fontWeight: 800, cursor: "pointer", letterSpacing: 0.5,
              background: !ad.trim() || !niyet.trim() || tokenBalance < 30 ? "rgba(255,255,255,0.06)" : "linear-gradient(135deg,rgba(80,30,140,0.95),rgba(140,60,220,0.85),rgba(80,30,140,0.95))",
              border: !ad.trim() || !niyet.trim() || tokenBalance < 30 ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(192,132,252,0.5)",
              color: !ad.trim() || !niyet.trim() || tokenBalance < 30 ? "rgba(255,255,255,0.3)" : "#fff",
              boxShadow: ad.trim() && niyet.trim() && tokenBalance >= 30 ? "0 0 28px rgba(192,132,252,0.35)" : "none",
            }}>
              🃏 Kartlarımı Çek
            </button>
          </div>
        </div>
      )}

      {/* ===== KART SEÇ ===== */}
      {ekran === "kart-sec" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", paddingBottom: 120, animation: "fade-yukari 0.6s ease backwards" }}>
          <div style={{ padding: "52px 24px 20px" }}>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#fff", marginBottom: 4 }}>Kartların Seni Bekliyor</div>
            <div style={{ fontSize: 12, color: "rgba(192,132,252,0.6)" }}>
              {!acikKartlar[0] ? "Geçmişini temsil eden kartı çevir" :
               !acikKartlar[1] ? "Şimdini temsil eden kartı çevir" :
               !acikKartlar[2] ? "Geleceğini temsil eden kartı çevir" :
               "Tüm kartlar açıldı ✨"}
            </div>
          </div>

          <div style={{ margin: "0 24px 28px", height: 1, background: "linear-gradient(90deg,transparent,rgba(192,132,252,0.4),transparent)" }} />

          {/* Kartlar */}
          <div style={{ padding: "0 24px", display: "flex", justifyContent: "space-around", alignItems: "flex-start", marginBottom: 32 }}>
            {["gecmis", "simdi", "gelecek"].map((poz, i) => (
              <TarotKart
                key={poz}
                kart={kartlar[i]}
                pozisyon={poz}
                acik={acikKartlar[i]}
                onTikla={() => {
                  // Sırayla açılsın
                  if (i === 0 || acikKartlar[i - 1]) kartAc(i);
                }}
              />
            ))}
          </div>

          {/* Kart açıldıkça anlam göster */}
          {acikKartlar.some(Boolean) && (
            <div style={{ margin: "0 24px", background: "rgba(15,8,30,0.8)", border: "1px solid rgba(192,132,252,0.2)", borderRadius: 16, padding: "16px", animation: "fade-yukari 0.4s ease backwards" }}>
              <div style={{ fontSize: 11, color: "rgba(192,132,252,0.6)", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 10 }}>✦ Çekilen Kartlar</div>
              {["gecmis", "simdi", "gelecek"].map((poz, i) => {
                const pozIsim = ["Geçmiş", "Şimdi", "Gelecek"];
                if (!acikKartlar[i] || !kartlar[i]) return null;
                return (
                  <div key={poz} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, animation: "fade-yukari 0.4s ease backwards" }}>
                    <div style={{ fontSize: 11, color: "rgba(192,132,252,0.5)", width: 50, flexShrink: 0 }}>{pozIsim[i]}</div>
                    <div style={{ fontSize: 12, color: "#C084FC", fontWeight: 700 }}>{kartlar[i].tr}</div>
                    <div style={{ fontSize: 10, color: "rgba(255,255,255,0.35)" }}>— {kartlar[i].anlam}</div>
                  </div>
                );
              })}
            </div>
          )}

          {hata && (
            <div style={{ margin: "16px 24px 0", padding: "12px 16px", borderRadius: 12, background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#FCA5A5", fontSize: 13 }}>
              ⚠️ {hata}
            </div>
          )}

          {/* Alt buton */}
          <div style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 420, padding: "16px 24px 100px", background: "linear-gradient(to top,rgba(10,3,20,0.98) 60%,transparent)", zIndex: 20 }}>
            {!tumKartlarAcikMi ? (
              <div style={{ textAlign: "center", fontSize: 13, color: "rgba(192,132,252,0.5)", fontStyle: "italic" }}>
                Sırayla kartlarına dokun...
              </div>
            ) : (
              <button onClick={tarotBak} style={{
                width: "100%", padding: "18px", borderRadius: 16,
                background: "linear-gradient(135deg,rgba(80,30,140,0.95),rgba(140,60,220,0.85),rgba(80,30,140,0.95))",
                border: "1px solid rgba(192,132,252,0.5)", color: "#fff",
                fontSize: 16, fontWeight: 800, cursor: "pointer",
                boxShadow: "0 0 28px rgba(192,132,252,0.35)", animation: "fade-yukari 0.4s ease backwards",
              }}>
                🔮 Lunara'dan Yorumu Al — 🪙 30
              </button>
            )}
          </div>
        </div>
      )}

      {/* ===== YÜKLENİYOR ===== */}
      {ekran === "yukleniyor" && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "0 32px", textAlign: "center" }}>
          <div style={{ fontSize: 70, marginBottom: 32, animation: "donme 6s linear infinite", filter: "drop-shadow(0 0 24px rgba(192,132,252,0.7))" }}>🔮</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>Lunara kartları okuyor...</div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", lineHeight: 1.8, fontStyle: "italic" }}>
            Geçmişin, şimdinin ve<br />geleceğin enerjisi birleşiyor
          </div>
          <div style={{ display: "flex", gap: 14, marginTop: 40 }}>
            {["🌙", "⭐", "💫"].map((s, i) => (
              <div key={i} style={{ fontSize: 24, animation: `yildiz-titreme 1.5s ${i * 0.3}s ease-in-out infinite` }}>{s}</div>
            ))}
          </div>
        </div>
      )}

      {/* ===== SONUÇ ===== */}
      {ekran === "sonuc" && sonuc && (
        <div style={{ position: "relative", zIndex: 10, minHeight: "100vh", paddingBottom: 100, animation: "fade-yukari 0.8s ease backwards" }}>
          <div style={{ padding: "52px 24px 20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <div style={{ width: 48, height: 48, borderRadius: 14, background: "rgba(192,132,252,0.15)", border: "1px solid rgba(192,132,252,0.4)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, animation: "parlama 3s ease-in-out infinite" }}>🔮</div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>Lunara</div>
                <div style={{ fontSize: 11, color: "rgba(192,132,252,0.6)" }}>Sezgisel Tarot Rehberi</div>
              </div>
            </div>

            {/* Çekilen kartlar özeti */}
            <div style={{ display: "flex", justifyContent: "space-around", marginBottom: 8 }}>
              {kartlar.map((kart, i) => kart && (
                <div key={i} style={{ textAlign: "center" }}>
                  <div style={{ width: 56, height: 96, borderRadius: 7, overflow: "hidden", border: "1px solid rgba(192,132,252,0.4)", marginBottom: 6 }}>
                    <img src={kart.url} alt={kart.tr} style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      onError={e => { e.target.parentElement.style.background = "#3B1F6B"; e.target.style.display = "none"; }} />
                  </div>
                  <div style={{ fontSize: 9, color: "#C084FC", fontWeight: 700 }}>{kart.tr}</div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ margin: "0 24px 24px", height: 1, background: "linear-gradient(90deg,transparent,rgba(192,132,252,0.5),transparent)" }} />

          <div style={{ padding: "0 24px" }}>
            <div style={{ fontSize: 11, color: "rgba(192,132,252,0.7)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 16 }}>✦ Tarot Yorumu</div>
            <div style={{ background: "rgba(15,8,30,0.8)", border: "1px solid rgba(192,132,252,0.2)", borderRadius: 20, padding: "24px" }}>
              <div style={{ fontSize: 14, color: "rgba(255,255,255,0.85)", lineHeight: 1.9, fontStyle: "italic", whiteSpace: "pre-wrap" }}>
                {sonuc}
              </div>
            </div>

            <button onClick={async () => {
              const kartIsimleri = kartlar.map((k, i) => `${["Geçmiş","Şimdi","Gelecek"][i]}: ${k?.tr}`).join(" | ");
              const metin = `🔮 Lunara'dan Tarot Yorumum:\n${kartIsimleri}\n\n"${sonuc}"\n\n✨ Remil'de tarot bak → https://www.remil.app`;
              if (navigator.share) { try { await navigator.share({ title: "Tarot", text: metin }); } catch (e) {} }
              else { navigator.clipboard.writeText(metin); alert("Kopyalandı!"); }
            }} style={{ width: "100%", padding: "14px", borderRadius: 14, marginTop: 16, background: "rgba(192,132,252,0.08)", border: "1px solid rgba(192,132,252,0.25)", color: "rgba(192,132,252,0.8)", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
              📤 Yorumu Paylaş
            </button>

            <button onClick={() => { ssSifirla(); setEkran("form"); setAcikKartlar([false,false,false]); setSonuc(null); setHata(""); setKartlar([null,null,null]); }} style={{ width: "100%", padding: "14px", borderRadius: 14, marginTop: 10, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.4)", fontSize: 13, cursor: "pointer" }}>
              🃏 Yeni Kartlar Çek
            </button>

            <button onClick={() => navigate("/")} style={{ width: "100%", padding: "12px", borderRadius: 14, marginTop: 8, background: "transparent", border: "none", color: "rgba(255,255,255,0.3)", fontSize: 13, cursor: "pointer" }}>
              Ana Sayfaya Dön
            </button>
          </div>
        </div>
      )}
    </div>
  );
}